export const FILTER_STATUS_DOT_CLASS = {
  active: "bg-success-500",
  inactive: "bg-error-500",
} as const;

export type FilterStatusDot = keyof typeof FILTER_STATUS_DOT_CLASS;

export function statusDotClass(isActive: boolean): string {
  return isActive
    ? FILTER_STATUS_DOT_CLASS.active
    : FILTER_STATUS_DOT_CLASS.inactive;
}
